import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { Callback } from '../../modules/callback'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'lvc-reservation-required-block', {
  reservationRequiredCheckbox: 'Activer la billetterie',
  placeholder: 'Écrivez ici...',
  ticketingUrlLabel: 'URL de la billetterie',
  ticketingUrlTooltip:
    "C'est l'URL du service de billetterie que vous utilisez pour cet événement.",
  choose: 'Choisir',
  datepickerLabel: 'Date de mise en ligne',
})

Locale.getInstance().registerKeySet('en', 'lvc-reservation-required-block', {
  reservationRequiredCheckbox: 'Enable ticketing',
  placeholder: 'Write here...',
  ticketingUrlLabel: 'Ticketing service URL',
  ticketingUrlTooltip: 'This is the URL of the ticketing service you are using for this event.',
  choose: 'Choose',
  datepickerLabel: 'Publication date',
})

export interface LvcReservationRequiredBlock {
  title: string
  placeholder: string
  open: boolean
  defaultValue: any
  value: string
  paid: boolean
}

export class LvcReservationRequiredBlock extends MinzeElement {
  changeCb = Callback.attach(this.onChange.bind(this))
  changeReservationRequiredCb = Callback.attach(this.onChangeReservationRequired.bind(this))
  onDateOfSaleChangeCb = Callback.attach(this.onChangeDateOfSale.bind(this))

  attrs: Attrs = [
    'ticketing-url',
    'reservation-required',
    'paid',
    'on-ticketing-url-change',
    'ticketing-url-error',
    'on-reservation-required-change',
    'date-of-sale',
    'date-of-sale-error',
    'on-date-of-sale-change',
  ]

  reactive: Reactive = [
    ['value', ''],
    ['dateOfSaleValue', ''],
  ]

  static observedAttributes = [
    'title',
    'on-change',
    'ticketing-url-error',
    'date-of-sale',
    'reservation-required',
  ]

  errors: any = {
    ticketingUrl: false,
    date: false,
  }

  async onBlur(e: Event): Promise<void> {
    this.open = false
  }

  public async onChange(value: string | boolean): Promise<void> {
    const ticketingUrlEl = this.select(`[name="ticketingUrl"]`) as HTMLInputElement
    const ticketingUrlValue = ticketingUrlEl?.value || ''
    Callback.call(this.onTicketingUrlChange as string, ticketingUrlValue)
  }

  public async onChangeReservationRequired(value: boolean): Promise<void> {
    this.reservationRequired = value
    if (!value) {
      this.dateOfSaleValue = ''
      this.ticketingUrl = ''
      this.rerender()
    }
    Callback.call(this.onReservationRequiredChange as string, value)
  }

  public async onChangeDateOfSale() {
    const element = this.select('[name="date-of-sale"]')
    if (!element) return

    Callback.call(this.onDateOfSaleChange as string, element?.getAttribute('value'))
  }

  async onReady() {
    if (this.dateOfSale && this.dateOfSale !== true) this.dateOfSaleValue = this.dateOfSale
  }

  onDestroy(): Promise<void> | void {
    Callback.detach(this.changeCb)
    Callback.detach(this.changeReservationRequiredCb)
  }

  html = () => {
    return `
      <lvc-box display="flex" flexDirection="column" rowGap="8px">
        <lvc-box display="flex" alignItems="center" justifyContent="space-between">
          <lvc-checkbox name="reservationRequired" on-change="${this.changeReservationRequiredCb}" default-value="${this.reservationRequired}" checked="${this.reservationRequired}" secondary-style="true" label="${Locale.getKey('lvc-reservation-required-block.reservationRequiredCheckbox')}"></lvc-checkbox>
        </lvc-box>

        ${
          this.reservationRequired || this.paid
            ? `
            <lvc-box display="flex" flexDirection="row" alignItems="flex-start" justifyContent="space-between" columnGap="16px">
              <lvc-box display="flex" flexGrow="1">
                <lvc-input default-value="${this.ticketingUrl || ''}" value="${this.ticketingUrl || ''}" on-change="${this.changeCb}" id="ticketingUrl" name="ticketingUrl" placeholder="${Locale.getKey('lvc-reservation-required-block.placeholder')}" label="${Locale.getKey('lvc-reservation-required-block.ticketingUrlLabel')}" error="${this.ticketingUrlError}" secondary-style="true" tooltip="true">
                  <div class="ticketing-url-tooltip-content" slot="tooltip-content">
                    <h3>${Locale.getKey('lvc-reservation-required-block.ticketingUrlTooltip')}</h3>
                  </div>
                </lvc-input>
              </lvc-box>
              <lvc-box display="flex" flexDirection="column" rowGap="4px">
                <lvc-text class="title" font-preset="small" color="#1E007D">${Locale.getKey('lvc-reservation-required-block.datepickerLabel')}</lvc-text>
                <lvc-datepicker on-change="${this.onDateOfSaleChangeCb}" name="date-of-sale" background="transparent" preset='dropdown' value="${this.dateOfSaleValue}" default-value="${this.dateOfSaleValue}" placeholder='${Locale.getKey('lvc-reservation-required-block.choose')}' placeholder-color='#1E007D' date-format-placeholder='false' error="${this.dateOfSaleError}" position='below'></lvc-datepicker>
              </lvc-box>
            </lvc-box>`
            : ``
        }
      </lvc-box>

      <div class="separator"></div>
    `
  }

  css = () => {
    return `
      :host {

      }

      .separator {
        height: 2px; 
        background-color: #1E007D4D;
        margin: 24px 0px ;
      }
      
      .title {
        height: 21px;
      }


    `
  }

  eventListeners: EventListeners = [[this, 'blur', this.onBlur.bind(this)]]
}
